// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const AlignLeftIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M6 1a1 1 0 00-2 0v22a1 1 0 102 0V1zm5 5a3 3 0 00-3 3v6a3 3 0 003 3h6a3 3 0 003-3V9a3 3 0 00-3-3h-6zm-1 3a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1h-6a1 1 0 01-1-1V9z"/></svg>'} />;

AlignLeftIcon.displayName = 'AlignLeftIcon';

export default AlignLeftIcon;
